import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';

import { IncodeContainer } from '../IncodeContainer';
import { type IncodeStepProps, INCODE_PROGRESS_STATUS, INCODE_PROGRESS_STEP, INCODE_ROUTES } from '../IncodeSDKHelpers';
import { usePostIncodeProgress } from '../progress/incodeProgress';

import styles from './IncodeMandatoryConsent.scss';

export const IncodeMandatoryConsent = ({
  BASE_URL,
  incodeSDK,
  incodeSession,
}: IncodeStepProps) => {
  const incodeContainerRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const { IncodeProgressLoading, postIncodeComplete } = usePostIncodeProgress();

  useEffect(() => {
    const abortController = new AbortController();

    const defaultCompleteParams = {
      abortController,
      fallbackNextStep: INCODE_ROUTES.CAPTURE_LICENSE,
      incodeSession,
      step: INCODE_PROGRESS_STEP.CONSENT,
    };

    incodeSDK.renderCombinedConsent(incodeContainerRef.current, {
      consentId: incodeSession?.consentId,
      onError: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.FAILED,
      }),
      onSuccess: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.SUCCESS,
      }),
      token: incodeSession,
    });

    return () => {
      abortController.abort();
    };
  }, [BASE_URL, history, incodeSDK, incodeSession, postIncodeComplete]);

  return (
    <>
      <IncodeProgressLoading />
      <div className={styles.incodeMandatoryConsent}>
        <IncodeContainer ref={incodeContainerRef} />
      </div>
    </>
  );
};
